const DIRECTION_OUTWARD = 0;
const DIRECTION_RETURN = 1;

export default function TripItemRailGroupService() {
    Object.assign(this, {
        isDirectionOutward,
        isDirectionReturn,
        getGroupTicketsPrice,
        getGroupThatWillAmendCandidate,
        getCandidateThatWillBeAmendedByGroup,
    });

    function isDirectionOutward(railGroup) {
        return railGroup.Direction === DIRECTION_OUTWARD;
    }

    function isDirectionReturn(railGroup) {
        return railGroup.Direction === DIRECTION_RETURN;
    }

    function getGroupTicketsPrice(railGroup) {
        return railGroup.Rails
            && railGroup.Rails.length
            && railGroup.Rails[0].TicketPrice;
    }

    function getGroupThatWillAmendCandidate(tripItemGroup, tripDetails) {
        return tripDetails.AmendmentInformation
            && tripDetails.AmendmentInformation.OldItem.TripItemGroupId === tripItemGroup.Id
            && tripDetails.AmendmentInformation.NewItem.TripItemGroupId
            || null;
    }

    function getCandidateThatWillBeAmendedByGroup(tripItemGroup, tripDetails) {
        return tripDetails.AmendmentInformation
            && tripDetails.AmendmentInformation.NewItem.TripItemGroupId === tripItemGroup.Id
            && tripDetails.AmendmentInformation.OldItem.TripItemGroupId
            || null;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/trip-item-group/trip-item-rail-group/trip-item-rail-group-service.js